import { Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceBalanceModifier } from '@features/invoices/types/invoiceBalanceModifier'

import { creditnoteBalanceModifierReferenceToTKey } from '../../../../../../elements/InvoicePaymentPane/constants/creditnoteBalanceModifierReferenceToTKey'
import { InvoiceBalanceModifierReference } from '../../../../../../elements/InvoicePaymentPane/enums/InvoiceBalanceModifierReference'
import { getInvoiceBalanceModifierReference } from '../../../../../../elements/InvoicePaymentPane/utils/getInvoiceBalanceModifierReference'

interface ModalBodyProps {
  balanceModifiers?: InvoiceBalanceModifier[]
  currencyId?: string
}

export const ModalBody = ({ balanceModifiers, currencyId }: ModalBodyProps): ReactElement => {
  const { t } = useTranslation()

  const validModifiers = balanceModifiers?.filter(({ modifierReference }) => {
    const modifierType = getInvoiceBalanceModifierReference(modifierReference)?.modifierType
    return (
      modifierType === InvoiceBalanceModifierReference.BankPayment ||
      modifierType === InvoiceBalanceModifierReference.InvoiceLateFee
    )
  })

  return (
    <>
      <Text>{t('invoices.void_credit_note_modal.body')}</Text>

      {validModifiers?.length ? (
        <>
          <Text>{t('invoices.void_credit_note_modal.subtitle')}</Text>
          {validModifiers.map(({ modifierReference, entryDate, amount }) => {
            const data = getInvoiceBalanceModifierReference(modifierReference)
            const modifierType = data?.modifierType
            const key = modifierType ? creditnoteBalanceModifierReferenceToTKey[modifierType] : ''
            const id = data?.modifierId

            return (
              <Text key={id}>
                {t(key)} {entryDate} ({amount} {currencyId})
              </Text>
            )
          })}
        </>
      ) : null}
    </>
  )
}
